import React from 'react'
import { MenuItemType } from '@utils/types'
import { EditableTitle, EditableDescription, WContainer, WImage } from '@components/atoms'
import { Star } from '@components/icons'
import { getIcon } from '@utils/icons'
import styles from './IdealeSection.module.sass'

interface Props {
  item: MenuItemType
  editMode?: boolean
  className?: string
}

const IdealeSection = (props: Props) => {
  const { item, editMode = false, className = '' } = props
  const theme = item.style || 'light'
  const hasDirectNote = editMode ? !!item.ctaLabel : !!item.ctaLabel?.trim?.()
  const notes = hasDirectNote
    ? [
        {
          key: `${item.pk || 'ideale'}-primary-note`,
          label: item.ctaLabel,
          iconNode: getIcon(item.icon) || <Star />,
        },
      ]
    : []

  return item ? (
    <div
      className={`${styles.root} ${item.borderTop ? styles['root--bt'] : ''} ${
        item.borderBottom ? styles['root--bb'] : ''
      } ${styles[`root--${theme}`]} ${className}`}
    >
      <WContainer className={styles.container}>
        <div className={styles.main}>
          {(editMode || !!item.name || !!item.description) && (
            <div className={styles.content}>
              <EditableTitle
                title={item.name}
                variant="h3"
                className={styles.title}
                editMode={editMode}
              />
              <EditableDescription
                description={item.description}
                className={styles.description}
                editMode={editMode}
              />
            </div>
          )}

          {notes.length > 0 && (
            <div className={styles.ctaBox}>
              {notes.map((x: any) => (
                <p key={x.key} className={styles.note}>
                  <span className={styles.ctaIcon}>{x.iconNode}</span>
                  {typeof x.label === 'string' ? <span>{x.label}</span> : x.label}
                </p>
              ))}
            </div>
          )}
        </div>

        {!!item.image && (
          <div className={styles.imageBox}>
            <WImage
              src={item.image}
              maxWidth={480}
              maxHeight={300}
              objectFit="cover"
              alt={item.alt}
              title={item.alt}
            />
          </div>
        )}
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default IdealeSection
